/** Geocoding suggestion calls — live address autocomplete for Profile Geolocation. */
import type { GeocodedPoint } from '@olimhub/shared'
import { apiClient } from '../client'

export interface LocationSuggestion {
  displayName: string
}

export const geocodingApi = {
  suggest: (q: string) =>
    apiClient.get<LocationSuggestion[]>('/geocoding/suggest', { params: { q } }).then((r) => r.data),

  // Resolves a chosen address string (e.g. a suggestion from suggest()) to
  // coordinates — called once on selection, not per keystroke.
  geocode: (q: string) =>
    apiClient.get<GeocodedPoint>('/geocoding/geocode', { params: { q } }).then((r) => r.data),
}
